import type { InsertScimDomainMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertScimDomainDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type InsertScimDomainInput = { domain: string };

export const useInsertScimDomain = createMutationHook({
  name: 'insertScimDomain',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.scim.addDomain.mutationOptions({ onSuccess }),
  mapInput: (variables: InsertScimDomainInput) => variables,
  invalidate: (trpc) => [trpc.frontend.scim.getConfig.queryKey()],
  mapResponse: (result: {
    domain: string;
    createdOn: string;
  }): InsertScimDomainMutation => ({
    insert_scim_domain: {
      __typename: 'ScimDomainOutput',
      domain: result.domain,
      createdOn: result.createdOn,
    },
  }),
  graphqlDocument: InsertScimDomainDocument,
  graphqlVariables: (variables: InsertScimDomainInput) => ({ ...variables }),
  evictFields: ['getScimConfig'],
});
